export const choirDocData = {
  zh: {
  "choirName": "咏歌堂",
  "choirNameEn": "Konzert Singers",
  "conductors": [
    {
      "name": "桂乃舜",
      "title": "艺术总监兼首席指挥",
      "avatar": "/images/kwei.jpeg",
      "bio": "桂乃舜是新加坡卓越的合唱指挥家之一，享誉国际。毕业于英国伦敦皇家音乐学院，获伦敦音乐学院院士，并于2013年荣获皇家音乐学院院士衔。",
      "education": "英国伦敦皇家音乐学院高级合唱指挥研究班毕业，伦敦音乐学院院士",
      "experience": "新加坡合唱界的领军人物，新加坡合唱节创始人兼艺术总监",
      "achievements": [
        "所指挥的合唱团多次获得世界级最重要的冠军大奖，斩获超过一百多项国际金奖",
        "多次荣获来自德国、意大利、奥地利及捷克的最佳指挥奖",
        "担任“歌之旅”及“亚洲欢唱”著名国际合唱节系列的艺术总监",
        "担任新加坡合唱节的创始人兼艺术总监",
        "担任国家艺术理事会的合唱顾问和音乐鉴赏评估官员",
        "担任人民协会艺术顾问团的委员",
        "致力于培养本地合唱人才，近四成的新加坡合唱指挥出自其培训与教导"
      ],
      "philosophy": "音乐是心灵的桥梁，合唱是连接彼此的和声。我希望通过每一次演唱，让每一个听众都能感受到音乐的力量和美好。"
    },
    {
      "name": "冯克伦",
      "title": "指挥",
      "avatar": "/images/foong.jpeg",
      "bio": "冯克伦的指挥之路始于新加坡半职业合唱团“声乐联盟”，师从桂乃舜。他还接受了多位声乐及指挥大师的指导，如佩德罗·蒙泰罗教授、马斯特罗·加博尔·霍勒鲁恩等。冯克伦是新加坡唯一一位在小学、中学和初级学院组别中均获得新加坡青年节“荣誉金奖”的指挥。目前，他指挥圣安德烈初级学院、联邦中学和南华中学等顶尖合唱团。",
      "education": "圣约瑟大学合唱指挥硕士（优等生），伦敦音乐学院合唱指挥研究员文凭",
      "experience": "经常受邀担任国际比赛评委和合唱指挥导师，曾任首届新加坡合唱节艺术总监",
      "achievements": [
        "拥有圣约瑟大学合唱指挥硕士学位（优等生）和伦敦音乐学院合唱指挥研究员文凭",
        "新加坡唯一一位在小学、中学和初级学院组别中均获得新加坡青年节“荣誉金奖”的指挥",
        "自2013年起，率领合唱团在新加坡青年节中屡获优等奖",
        "在意大利、捷克、俄罗斯、中国等多国的合唱比赛中获得金奖和总冠军，并三次荣获“最佳指挥奖”",
        "经常受邀担任国际比赛评委和合唱指挥导师",
        "曾指挥新加坡华乐团“和谐之声”音乐会（带领200人的合唱团），并为陈洁仪“我的音乐旅程”音乐会担任合唱指挥",
        "担任音乐人才发展中心（MTDC）项目的副指挥，培养新加坡中学的年轻歌者",
        "2015年担任首届新加坡合唱节艺术总监，汇聚1000多名歌者演出庆祝SG50"
      ],
      "philosophy": "用音乐传递美好，用和声连接心灵。"
    }
  ],
  "hero": {
    "subtitle": "用音乐点亮生活，用和声温暖人心。我们是一支充满激情的合唱团，致力于创造美妙的音乐体验。",
    "primaryCta": "欣赏我们的演出",
    "secondaryCta": "加入我们"
  },
  "intro": "咏歌堂（Konzert Singers）是一支充满活力的合唱团体，汇聚了一群热爱音乐、追求卓越的歌唱爱好者。\n\n我们坚信，声音不仅是听觉的享受，更是心灵的共鸣。在这里，不同年龄、不同背景的团员们因为对音乐的共同热爱而相聚。无论是朝气蓬勃的青年，还是沉稳睿智的长者，我们都用最真挚的情感，演绎着每一首动人的乐章。\n\n我们崇尚多元文化，既深情演绎中华文化的博大精深，也热情拥抱世界音乐的丰富多彩。我们相信，音乐是跨越国界的语言，是最动人的文化桥梁。\n\n咏歌，咏歌！在咏歌堂，我们用歌声记录生活，用和声传递真善美。欢迎加入我们，一起感受合唱的魅力，让音乐点亮生活！",
  "aboutImage": "/images/about.webp",
  "qrcode": "/images/qrcode.png",
  "logo": "/images/logo-03.png",
  "youtube": {
    "channel": "https://www.youtube.com/@KonzertSingers"
  },
  "videos": [
    {
      "title": "拥抱夕阳",
      "description": "咏歌堂演绎经典中文作品，深情款款，温暖人心。",
      "url": "https://www.youtube.com/watch?v=ZATHqkgieAo"
    },
    {
      "title": "青春不留白",
      "description": "洋溢着青春活力的旋律，唱出对未来的无限憧憬。",
      "url": "https://www.youtube.com/watch?v=Lpgh9dMAoLc"
    },
    {
      "title": "歌唱高山和大海",
      "description": "气势磅礴的自然颂歌，展现合唱艺术的宏大叙事。",
      "url": "https://www.youtube.com/watch?v=3skdoKEcqCY"
    },
    {
      "title": "细水长流",
      "description": "经典新谣改编，如涓涓细流般诉说着岁月的故事。",
      "url": "https://www.youtube.com/watch?v=aQU43BwE6x8"
    },
    {
      "title": "Hope 希望",
      "description": "充满正能量的主题作品，用歌声传递希望与力量。",
      "url": "https://www.youtube.com/watch?v=2lriBVwsjJI"
    },
    {
      "title": "让友谊的歌声展开翅膀",
      "description": "用歌声传递友谊，用和声连接心灵。",
      "url": "https://www.youtube.com/watch?v=VTZvkvAnioY"
    }
  ],
  "performances": [
    {
      "name": "咏歌·初韵",
      "date": "2026-05-10",
      "intro": "这是一场庆祝春天的合唱盛宴，我们将带来多首经典与现代交织的合唱作品。诚邀您与我们一同沉浸在美妙的和声中，感受初韵的生机与活力。",
      "image": "/images/about.webp",
      "venue": "The ARTS HOUSE",
      "link": "/firstchord"
    },
    {
      "name": "SG60 新加坡建国60周年合唱节",
      "date": "2025-08-17",
      "intro": "共庆狮城甲子华诞，咏歌堂将与多支优秀合唱团同台献艺，用歌声祝福祖国。",
      "image": "/images/sg60.jpg",
      "venue": "新加坡"
    },
    {
      "name": "SOTA 音乐家协会15周年庆典音乐会",
      "date": "2025-11-09",
      "intro": "致敬艺术传承，共谱华美乐章。咏歌堂受邀参加新加坡艺术学院音乐家协会成立十五周年庆典演出。",
      "image": "/images/sota-15th.JPG",
      "venue": "SOTA 音乐厅"
    },
    {
      "name": "第八届新加坡国际华文合唱节",
      "date": "2026-03-10",
      "intro": "主办：新加坡合唱总会 Choral Association (Singapore)",
      "image": "/images/20260310.jpg",
      "venue": "新加坡华族文化中心表演厅，九楼"
    }
  ],
  "footer": {
    "about": "用音乐传递美好，用和声连接心灵。我们致力于创造高水准的音乐体验，为社区带来艺术的享受与文化的滋养。",
    "schedule": [
      "每周二 19:30 - 21:30"
    ],
    "location": "排练地点：南洋普宁会馆8楼",
    "copyright": "© 2026 咏歌堂 Konzert Singers. 保留所有权利. | 让音乐点亮生活"
  },
  "contact": {
    "title": "联系我们",
    "intro": "如果您对合唱艺术充满热情，渴望寻找志同道合的伙伴；或者您希望与我们进行演出合作与艺术交流，欢迎随时联系我们。",
    "email": "konzertsingers@gmail.com",
    "phone": "",
    "address": "8th floor recital Studio 26 Lor 27A Geylang, Singapore 388115",
    "website": "konzertsingers.sg",
    "socials": [
      {
        "name": "Facebook",
        "href": "https://facebook.com/KonzertSingers"
      },
      {
        "name": "Instagram",
        "href": "https://instagram.com/KonzertSingers"
      },
      {
        "name": "YouTube",
        "href": "https://www.youtube.com/@KonzertSingers"
      }
    ]
  }
},
  en: {
  "choirName": "Konzert Singers",
  "conductors": [
    {
      "name": "Nelson Kwei",
      "title": "Artistic Director and Principal Conductor",
      "avatar": "/images/kwei.jpeg",
      "bio": "Nelson Kwei is one of Singapore’s leading choral conductors, internationally recognised for his contributions to choral music. He holds a Fellowship from the London College of Music and an Associateship from the Royal Academy of Music (2013).",
      "education": "Advanced Post-Graduate qualification in Choral Conducting from Royal Academy of Music; Fellowship from London College of Music",
      "experience": "Singapore's premier choral conductor, Artistic Director for prominent international choral festivals",
      "achievements": [
        "Holds a Fellowship from the London College of Music, a Licentiate in Singing from the Guildhall School of Music, and an Advanced Post-Graduate qualification in Choral Conducting from the Royal Academy of Music.",
        "Awarded the rare Associateship by the Royal Academy in 2013 for his exceptional contributions to choral music.",
        "Led Singaporean choirs to collect an unprecedented 254 gold medals, distinction awards, and champion titles at national and international competitions.",
        "Led the National University of Singapore Choir to win the coveted 'Choir of the World Award – Pavarotti Trophy' in 2018, the first and only Singaporean choir to attain this honor.",
        "Repeatedly recognized with Outstanding Conductor and Best Conductor awards at events like the World Choir Games, Mendelssohn-Bartholdy International Choral Competition, and Concorso Corale Internazionale.",
        "Serves as Artistic Director for prominent international choral festivals including the Singapore Choral Festival, 'A Voyage of Songs,' and 'Asia Cantate'.",
        "Founding Director of the Asian Choral Association and first Chairman of the Musicians Society of Singapore.",
        "Regularly invited as an adjudicator and clinician at top international choral competitions and festivals, including the World Choir Games Series."
      ],
      "philosophy": "Music is the bridge of the soul; choral singing is the harmony that connects us. I hope that through every performance, every listener can feel the power and beauty of music."
    },
    {
      "name": "Foong Hak Luen",
      "title": "Conductor",
      "avatar": "/images/foong.jpeg",
      "bio": "He started his choral journey singing in one of Singapore’s premier semi-professional choir, The Vocal Consort. Hak Luen was invited as Adjudicator for International Choral Competitions as well as Clinician for Choral Conducting both locally and abroad. Furthermore, Hak Luen conducted the Singapore Chinese Orchestra's 'Harmony Voices' concert leading a 200-strong choir, and served as the choral conductor for Kit Chan's 'My Musical Journey' concert. Currently, he conducts top choirs including St. Andrew's Junior College, Commonwealth Secondary School, and Nan Hua High School.",
      "education": "Masters in Choral Conducting (Magna Cum Laude) from University of St. Joseph; Fellowship from London College of Music",
      "experience": "Invited as Adjudicator for International Choral Competitions and Clinician for Choral Conducting locally and abroad",
      "achievements": [
        "Masters in Choral Conducting (Magna Cum Laude) from the University of St. Joseph, Fellowship in Choral Conducting from London College of Music and Associate in Voice from the Trinity College of London.",
        "The only choral conductor in Singapore to have choirs attained the Gold with Honours Awards at the Primary, Secondary and Junior College level.",
        "Led his choirs to attain Distinction awards in the Singapore Youth Festival Arts Presentation since 2013.",
        "Choirs under his direction have attained Gold awards, Category Champions and Grand Prizes from international choral competitions held in Italy, Czech Republic, Slovakia, Russia, China, Taiwan, Thailand, Hong Kong and Malaysia.",
        "Specially awarded the Outstanding Conductor Prize for his excellent work with choirs at these competitions in 2009, 2011 and 2013.",
        "Invited as Adjudicator for International Choral Competitions as well as Clinician for Choral Conducting both locally and abroad."
      ],
      "philosophy": "Conveying beauty through music; connecting hearts through harmony."
    }
  ],
  "hero": {
    "subtitle": "Let music light up life and harmony warm hearts. We are a passionate choir creating beautiful musical experiences.",
    "primaryCta": "Watch Our Performances",
    "secondaryCta": "Join Us"
  },
  "intro": "Konzert Singers is a vibrant choral ensemble, bringing together a community of music lovers who strive for excellence.\n\nWe believe that sound is not merely a pleasure for the ears, but a resonance of the soul. Here, members of different ages and backgrounds gather for their shared passion for music. Whether it is the energetic youth or the wise and steady seniors, we all interpret every moving movement with the most sincere emotions.\n\nWe embrace cultural diversity, passionately performing the profound depths of Chinese culture while warmly welcoming the richness of world music. We believe that music is a universal language and the most touching bridge between cultures.\n\nSing, and let the song live on! At Konzert Singers, we record life through song and convey truth, goodness, and beauty through harmony. Join us to experience the charm of choral singing and let music light up your life!",
  "aboutImage": "/images/about.webp",
  "qrcode": "/images/qrcode.png",
  "logo": "/images/logo-03.png",
  "youtube": {
    "channel": "https://www.youtube.com/@KonzertSingers"
  },
  "videos": [
    {
      "title": "Embracing the Sunset",
      "description": "Konzert Singers perform a classic Chinese piece with deep emotion and warmth.",
      "url": "https://www.youtube.com/watch?v=ZATHqkgieAo"
    },
    {
      "title": "Youth Unfading",
      "description": "A melody brimming with youthful vitality, singing out infinite aspirations for the future.",
      "url": "https://www.youtube.com/watch?v=Lpgh9dMAoLc"
    },
    {
      "title": "Sing of Mountain and Sea",
      "description": "A majestic ode to nature, showcasing the grand narrative of choral art.",
      "url": "https://www.youtube.com/watch?v=3skdoKEcqCY"
    },
    {
      "title": "The Stream Flows",
      "description": "An adaptation of a classic Xinyao song, telling the story of time like a gentle flowing stream.",
      "url": "https://www.youtube.com/watch?v=aQU43BwE6x8"
    },
    {
      "title": "Hope",
      "description": "A theme full of positive energy, conveying hope and strength through song.",
      "url": "https://www.youtube.com/watch?v=2lriBVwsjJI"
    },
    {
      "title": "Let Friendship's Song Take Wing",
      "description": "A song that celebrates the power of friendship, connecting hearts through harmony.",
      "url": "https://www.youtube.com/watch?v=VTZvkvAnioY"
    }
  ],
  "performances": [
    {
      "name": "Ode to Song · First Rhyme",
      "date": "2026-05-10",
      "intro": "A choral celebration of spring, featuring a beautiful blend of classic and contemporary pieces. We invite you to immerse yourself in harmonious melodies and experience the vitality of the first rhyme.",
      "image": "/images/about.webp",
      "venue": "The ARTS HOUSE",
      "link": "/firstchord"
    },
    {
      "name": "SG60 Singapore Choral Festival",
      "date": "2025-08-17",
      "intro": "Celebrating Singapore's 60th anniversary, Konzert Singers will perform alongside other outstanding choirs to bless the nation with song.",
      "image": "/images/sg60.jpg",
      "venue": "Singapore"
    },
    {
      "name": "SOTA Musicians Association 15th Anniversary Concert",
      "date": "2025-11-09",
      "intro": "Honoring the heritage of art and composing a beautiful chapter together. Konzert Singers is invited to perform at the SOTA Musicians Association's 15th Anniversary Celebration.",
      "image": "/images/sota-15th.JPG",
      "venue": "SOTA Concert Hall"
    },
    {
      "name": "8th Singapore International Chinese Choral Festival",
      "date": "2026-03-10",
      "intro": "Organizer: Choral Association (Singapore)",
      "image": "/images/20260310.jpg",
      "venue": "SCCC Auditorium, Level 9, 1 Straits Boulevard Singapore 018906"
    }
  ],
  "footer": {
    "about": "Sharing beauty through music, connecting hearts in harmony. We are committed to creating high-quality musical experiences and bringing artistic enjoyment and cultural enrichment to the community.",
    "schedule": [
      "Tuesday 19:30 – 21:30"
    ],
    "location": "Rehearsal: Nanyang Pho Leng Hui Kuan, 8F",
    "copyright": "© 2026 Konzert Singers. All rights reserved. | Let music light up life"
  },
  "contact": {
    "title": "Contact Us",
    "intro": "If you are passionate about choral art and looking for like-minded partners, or if you wish to collaborate with us for performances and artistic exchange, please feel free to contact us.",
    "email": "konzertsingers@gmail.com",
    "phone": "",
    "address": "8th floor recital Studio 26 Lor 27A Geylang, Singapore 388115",
    "website": "konzertsingers.sg",
    "socials": [
      {
        "name": "Facebook",
        "href": "https://facebook.com/konzertsingers"
      },
      {
        "name": "Instagram",
        "href": "https://instagram.com/konzertsingers"
      },
      {
        "name": "YouTube",
        "href": "https://www.youtube.com/@KonzertSingers"
      }
    ]
  }
}
};
